export { default } from "./box-content";
